import { AppThunk } from '../types';
import { setCountiesErrorAction, setCountiesFetchStatusAction, setCountyAction } from './reducer';
import { createFetchedSuccess, createFetchedWithError, createFetchInProgress } from 'types/rest/IFetchStatus';
import { eUSAState } from '../../ui-toolkit/enums/states';
import { getCountyForState } from '../../ui-toolkit/orders/searchOrder/API/SearchOrdersAPI';

export const getCountyForStateRequestAction =
  (state: eUSAState): AppThunk =>
  async (dispatch) => {
    dispatch(setCountiesErrorAction(null));
    dispatch(setCountiesFetchStatusAction(createFetchInProgress()));
    try {
      const response = await getCountyForState(state);
      dispatch(setCountyAction({ state, counties: response }));
      dispatch(setCountiesFetchStatusAction(createFetchedSuccess()));
    } catch (e: any) {
      dispatch(setCountiesErrorAction(e.message));
      dispatch(setCountiesFetchStatusAction(createFetchedWithError()));
    }
  };

export const getCountyForStateAction =
  (state: eUSAState): AppThunk =>
  (dispatch, getState) => {
    const counties = getState().counties.counties[state];
    if (counties.length === 0) {
      dispatch(getCountyForStateRequestAction(state));
    }
  };
